import React from 'react'
import { Helmet } from 'react-helmet-async'
import { SITE_URL } from '@/lib/seo'

type AppFallbackSEOProps = {
  noindex?: boolean
  nofollow?: boolean
}

export function AppFallbackSEO({ noindex = false, nofollow = false }: AppFallbackSEOProps) {
  const title = 'Keep your child safer on their iPhone | Joey'
  const description =
    'AI Smart Alerts for parents. Joey spots bullying, risky contacts, money asks and safety risks across iMessage, Google, YouTube, WhatsApp and SnapChat - no spyware.'
  const robots = `${noindex ? 'noindex' : 'index'}, ${nofollow ? 'nofollow' : 'follow'}`
  const image = `${SITE_URL}/img/og/open_graph.png`

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {(noindex || nofollow) && <meta name="robots" content={robots} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
    </Helmet>
  )
}
